<!--
商品列表页过滤器

使用说明：

<ProductListFilter
 :search="'关键字'"
 :affordable="是否勾选我能兑换，单项传值，true/false"
 :orderType="orderType" 
 :direction="direction"
  @onChange="onChange"
 />

-->

<template>
  <div class="wrap">
    <!-- 浮动筛选框 -->
    <div class="float-bar">
      <div v-if="query || isSearchMode" class="search-wrap">
        <div class="search-box">
          <i class="icon icon-search-gray"></i>
          <input type="search" placeholder="搜索关键词" v-model="query" @keyup.enter="$emit('onSearch', query)">
        </div>
      </div>
      <div class="order-btn-list" :class="{flex:  easyUser}">
        <div class="order-btn" :class="{'active': currOrder == ''}">
          <a href="javascript:;" @click="changeOrder('')">默认</a>
        </div>
        <div class="order-btn" :class="{'active': currOrder == 'price'}">
          <a href="javascript:;" @click="changeOrder('price')">
            价格
            <i class="order-status-icon" :class="[currDir]"></i>
          </a>
        </div>
        <div class="order-btn" :class="{'active': currOrder == 'sale'}">
          <a href="javascript:;" @click="changeOrder('sale')">销量</a>
        </div>
      </div>
      <template v-if="!easyUser">
          <label class="filter-btn"  @click="()=>{affordableVal = !affordableVal}">
            <div class="checkbox" :class="{isSelected : affordableVal}"></div>  我能兑换的
          </label>
      </template>
    </div>
    <!-- 静态站位框 -->
    <div class="static-bar" :class="{'show-search':search}">
      <!-- 没有任何用处，纯粹就是用来占住列表顶部筛选框同样大小的空间 -->
    </div>
  </div>
</template>

<script>
import store from '../../api/store'

export default {
  props: ["search", "affordable","orderType","direction"],
  data() {
    return {
      isSearchMode: false,
      query: this.search,
      currOrder: this.orderType,
      currDir: (this.direction == 1 ? "asc":"desc"),
      affordableVal : this.affordable,
      easyUser: store.loginedUser.easyUser,
    };
  },
  watch:{
    affordable: function(o,n){console.log('RUN: '+ o);
      this.affordableVal = o;
    },
    affordableVal: function(){
      this.emitFilterChanged();
    },
    search: function(n,o){
      this.query = n;
      if(n){
        this.isSearchMode = true;
      }
    }
  },
  created() {
    this.currOrder = "";
  },
  methods: {
    emitFilterChanged(){
      this.$emit('onChange', 
        this.query,
        this.affordableVal,
        this.currOrder,
        (this.currDir == 'asc' ? 1 : 2)
      )
    },
    changeOrder(orderType) {
      if (this.currOrder == "price" && orderType == "price") {
        this.currDir = this.currDir == "asc" ? "desc" : "asc";
      } else {
        if(orderType == 'price'){
          this.currDir='asc';
        }else{
          this.currDir = "desc";
        }
      }
      this.currOrder = orderType;
      this.emitFilterChanged();
    }
  }
};
</script>

<style lang="less" scoped>
@defaultFontColor: #666666; //默认字体颜色
@searchFontSize: 3.7333vw; //搜索框字体大小
@searchBoxHeight: 8.93vw; //搜索框内部高度
@searchBoxMarginV: 3.2vw; //搜索框垂直方向的边距
@filterBtnHeight: 12vw; //排序和筛选按钮高度
@filterFontSize: 4vw; //排序和筛选字体大小

.wrap {
}

.flex {
  display: flex !important;
  justify-content: space-around;
}

.float-bar {
  position: fixed;
  z-index: 3;
  top: 0;
  width: 100vw;
  background: #fff;
  border-bottom: 1px solid #e6e6e6;
}

.static-bar {
  height: @filterBtnHeight + 3.6vw;
  &.show-search {
    height: @filterBtnHeight + @searchBoxMarginV + 10vw;
  }
}

.search-box {
  @boxWidth: 92vw;
  @boxHeight: 8.93vw;
  @iconMarginH: 2.66vw;

  width: @boxWidth;
  height: @boxHeight;
  border: 1px solid #d2d0dd;
  border-radius: 1.33vw;
  margin: 3.2vw auto 0vw;
  font-size: @searchFontSize;
  color: @defaultFontColor;

  .icon-search-gray {
    background-image: url(../../assets/icon-search-gray.png);
    width: @searchFontSize;
    height: @searchFontSize;
    float: left;
    margin-top: (@boxHeight - @searchFontSize) / 2;
    margin-left: @iconMarginH;
  }

  input {
    margin-left: @iconMarginH;
    height: @boxHeight;
    width: @boxWidth - @searchFontSize - 2 * @iconMarginH - 4vw;
  }
}

.order-btn-list {
  display: inline-block;
}

.order-btn,
.filter-btn {
  display: inline-block;
  line-height: @filterBtnHeight;
  margin-left: 5.4vw;
  font-size: 4vw;
  color: @defaultFontColor;
}

.order-btn {
  a {
    position: relative;
    z-index: 1;
  }
  .order-status-icon {
    &:before,
    &:after {
      content: "";
      display: inline-block;
      width: 2.11vw;
      height: 1.06vw;
      background-size: cover;
      background-position: center;
      background-image: url(../../assets/icon-product-order-arrow.png);
      position: absolute;
      z-index: 2;
      top: 1vw;
      right: -3.5vw;
      transform: rotate(0deg);
    }
    &:after {
      top: 2.5vw;
      right: -3.5vw;
      transform: rotate(180deg);
    }
  }

  &.active {
    color: @themeColor;

    .order-status-icon {
      &.asc {
        &:before {
          background-image: url(../../assets/icon-product-order-arrow-up-active.png);
        }
        
      }
      &.desc {
        &:after {
          background-image: url(../../assets/icon-product-order-arrow-up-active.png);
        }
      }
    }
  }
}

.filter-btn {
  .checkbox {
    position: relative;
    display: inline-block;
      border: 1px solid #999999;
      width: @filterFontSize - 0.4vw;
      height: @filterFontSize - 0.4vw;
      border-radius: 0.533vw;
      vertical-align: middle;
      margin-bottom: 0.8vw;

    &.isSelected {
      background: @themeColor;
      border-color: @themeColor;

      &:after {
        content: "";
        background-image: url(//res.uuudian.com/hk_data/3d024b33-893b-41cd-b5c7-9518b04b0b44);
        background-repeat: no-repeat;
        background-size: contain;
        background-position: center;
        position: absolute;
        top: 50%;
        margin-top: 0 - (@filterFontSize * 0.8 / 2) - 0.4vw;
        left: 50%;
        margin-left: 0 - (@filterFontSize * 0.8 / 2);
        z-index: 2;
        width: @filterFontSize * 0.8;
        height: @filterFontSize * 0.8;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/products/ProductListFilter.vue